import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Col } from 'react-bootstrap';
import moment from 'moment';

import FormattedMessage from '../../../components/FormattedMessage';
import Confirm from '../../../components/Confirm/Confirm';
import Loading from '../../../components/Loading/Loading';
import { error, updateStepData, clearEstimation, estimate, requestUpgrade } from '../SubscribeActions';
import { getCountryName } from '../../../util/countries';
import { trackSubscriptionInfoConfirm } from '../../../util/mixpanel';

import deleteIcon from '../../../assets/images/delete-icon.svg';
import '../Subscribe.scss';

class Confirmation extends Component {
  static defaultProps = {
    isUpgrade: false,
    invoice: {},
    onNext: function () {},
    onBack: function () {},
  };

  constructor(props) {
    super(props);
    this.state = {
      coupon: '',
    };

    this.handleNextClick = this.handleNextClick.bind(this);
    this.applyCoupon = this.applyCoupon.bind(this);
    this.removeCoupon = this.removeCoupon.bind(this);
  }

  componentDidMount() {
    this.props.estimate(this.props.model);
  }

  componentWillUnmount() {
    this.props.clearEstimation();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sent != this.props.sent && this.props.sent === true) {
      this.setState({
        sent: this.props.sent,
      });
    }
    if (prevProps.paymentError != this.props.paymentError) {
      this.setState({
        paymentError: this.props.paymentError,
      });
    }
  }

  redirect() {
    if (this.state.sent === true && this.state.paymentError) {
      this.props.onBack();
    } else if (this.state.sent === true && !this.state.paymentError) {
      this.props.router.push('/');
    }
  }

  handleNextClick() {
    if (this.props.paymentLoading) {
      return false;
    }

    if (this.props.isUpgrade) {
      this.props.requestUpgrade(this.props.model).then(() => this.redirect());
    } else {
      var total = (this.props.estimation.total / 100).toFixed(2);

      this.props.updateStepData({
        ...this.props.model,
        total: total,
      });
      
      if(this.props.model) {
        trackSubscriptionInfoConfirm(this.props.model.planName, this.props.model.planType, this.state.coupon, total);
      }
      this.props.onNext();
    }
  }

  applyCoupon() {
    this.props
      .estimate({
        ...this.props.model,
        coupon: this.state.coupon,
      })
      .then(() => {
        this.props.updateStepData({
          ...this.props.model,
          coupon: this.state.coupon,
        });
        this.setState({ coupon: '' });
      })
      .catch((err) => {
        if (err.data.payment && err.data.payment.msg === 'error.payment.invalid_coupon') {
          this.setState({ coupon: '' });
          this.props.updateStepData({
            ...this.props.model,
            coupon: undefined,
          });
        }
      });
  }

  removeCoupon() {
    this.props.estimate({
      ...this.props.model,
      coupon: undefined,
    });
  }

  render() {
    const { app, model, estimation, isUpgrade } = this.props;

    if (!estimation.nextBilling) {
      return <div className='table-loading'><Loading /></div>;
    }

    return (
      <div className='billing_inner_content'>
        <p className='sub_title'>Please make sure this information is correct</p>
        <div className='confirmation_box'>
          <div>
            <span>Name:</span> {model.firstName} {model.lastName}
          </div>
          {model.company && (
            <div>
              <span>Company:</span> {model.company}
            </div>
          )}
          <div>
            <span>Country:</span> {getCountryName(model.country)}
          </div>

          {model.card && (
            <div>
              <span>Payment method:</span>
              <div className='details'>
                <div className={`card ${model.card.cardType.toLowerCase()}`}></div>
                **** **** **** {model.card.lastFour}
              </div>
            </div>
          )}

          <div>
            <span>Plan:</span> {model.planName}
          </div>
          <div>
            <span>Subscription type:</span> {model.planType === 'month' ? 'Monthly' : 'Annual'} subscription
          </div>
          <div>
            <span>
              Number of <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" plural="true" />:
            </span>{' '}
            {model.allowed}
          </div>
          {!estimation.isDowngrade && estimation.taxes && estimation.taxes.length > 0 && 
            <div>
              <span>Amount:</span> ${(estimation.subTotal / 100).toFixed(2)}
            </div>
          }
          {!estimation.isDowngrade && estimation.taxes && estimation.taxes.length > 0 &&
            estimation.taxes.map((t, i) => {
              return (
                <div key={i}>
                  <span>{t.description}:</span> ${(t.amount / 100).toFixed(2)}
                </div>
              );
            })}
          {estimation.discounts &&
            estimation.discounts.map((t, i) => {
              return (
                <div key={i}>
                  <span>{t.description}:</span> ${(t.amount / 100).toFixed(2)}
                </div>
              );
            })}
          <div>
            <span>Total amount:</span> ${(estimation.total / 100).toFixed(2)}
          </div>
          {isUpgrade && estimation.isUpgrade && (<div><span>Credits applied:</span> ${(estimation.creditsApplied / 100).toFixed(2)}</div>)}
          {isUpgrade && estimation.isUpgrade && (<div><span>Immediate charge:</span> ${(estimation.amountDue / 100).toFixed(2)}</div>)}
          <div>
            <span>Next billing date:</span> {moment.unix(estimation.nextBilling).format('DD MMM YYYY')}
          </div>
          {isUpgrade && estimation.isDowngrade && (
            <div>
              <span>Next billing amount:</span> ${(estimation.nextBillingAmount / 100).toFixed(2)}
            </div>
          )}
          <div className='coupon_details'>
            <span>Enter a coupon:</span>{' '}
            <div>
              {model.coupon ? (
                <div className='coupon_info'>
                  <span>{model.coupon}</span>
                  <Confirm
                    onConfirm={this.removeCoupon}
                    body={
                      <p>
                        Are you sure you want to remove <br />
                        this coupon?
                      </p>
                    }
                    confirmText="Remove"
                    icon={deleteIcon}
                    title="Remove coupon"
                  >
                    <Button className='btn_icon btn_clear'></Button>
                  </Confirm>
                </div>
              ) : (
                <input
                  type="text"
                  className='form-control'
                  value={this.state.coupon}
                  onChange={(e) => {
                    this.setState({ coupon: e.target.value });
                  }}
                />
              )}
              {!model.coupon && (
                <Button size='sm' onClick={this.applyCoupon}>
                  Apply Coupon
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className='action_box_billing'>
          <Button variant='secondary' onClick={this.props.onBack}>
            Back
          </Button>
          {!this.props.isUpgrade && (
            <Button variant='primary'  onClick={this.handleNextClick}>
              Next
            </Button>
          )}
          {this.props.isUpgrade && (
            <Button variant='primary' onClick={this.handleNextClick}>
              {this.props.paymentLoading ? 'Loading...' : 'Finish'}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (err) => dispatch(error(err)),
    clearEstimation: () => dispatch(clearEstimation()),
    updateStepData: (data) => dispatch(updateStepData(data)),
    estimate: (model) => dispatch(estimate(model)),
    requestUpgrade: (model) => dispatch(requestUpgrade(model)),
  };
};

const mapStateToProps = (state) => {
  return {
    app: state.app.app,
    model: state.subscription.model,
    estimation: state.subscription.estimation,
    sent: state.subscription.sent,
    paymentError: state.subscription.error,
    paymentLoading: state.subscription.paymentLoading,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Confirmation));
